import { ReactNode } from 'react';
import { FormProvider as Form, UseFormReturn } from 'react-hook-form';
import { BaseCSSProperties } from '@mui/styles';
import { ThemeProvider } from '@mui/material';
import React from 'react';
import FormProviderTheme from './FormProviderTheme';

// Re-export all components
export * from './components/Autocomplete';
export * from './components/InputSwitch';
export * from './components/InputField';
export * from './components/InputDate';
export * from './components/InputTime';
export * from './components/JewishDatePicker';
export * from './components/InputFile';
export * from './components/GoogleMapAutocomplete';
export * from './components/InputSelect';
export * from './components/InputSelectMultiple';
export * from './components/InputAutocomplete';
export * from './components/InputToggleButton';
export * from './components/InputRadioGroup';
export * from './components/InputCheckbox';
export * from './components/InputCheckboxGroup';
export * from './components/InputRating';
export * from './components/InputSignature';
export * from './components/LightButton';
export * from './components/DependentSelectInputs';
export * from './components/tinyMce';
export * from './components/CustomDatePicker';
export * from './components/CustomSlider';
export * from './components/InputSlider';
export * from './FormProviderTheme';

type Props = {
  children: ReactNode;
  methods: UseFormReturn<any>;
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
  sx?: BaseCSSProperties;
};

export const FormProvider: React.FC<Props> = ({ children, onSubmit, methods, sx }) => {
  const formTheme = FormProviderTheme();
  return (
    <ThemeProvider theme={formTheme}>
      <Form {...methods}>
        <form style={{ width: '100%', ...sx }} onSubmit={e => onSubmit?.(e)} noValidate>
          {children}
        </form>
      </Form>
    </ThemeProvider>
  );
};

export default FormProvider;
